import React, { useState, useEffect, useContext, useCallback } from "react";
import Spinner from "../../shared/Spinner";
// import Checkbox from "@material-ui/core/Checkbox";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormGroup from "@material-ui/core/FormGroup";
import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ResponsiveContext } from "../../shared/layout/ResponsiveContext";
import fidoPasskeyLogo from "../../assets/images/fido-passkey-logo.png";
import Delete from "@material-ui/icons/Delete";
import api from "../../utils/api";
import styles from "./AccountPage.module.css";
import platform from "platform";

import { Route, Switch } from "react-router-dom";

function base64URLToBuffer(base64URL) {
  const base64 = base64URL.replace(/-/g, "+").replace(/_/g, "/");
  const padLen = (4 - (base64.length % 4)) % 4;
  return Uint8Array.from(atob(base64.padEnd(base64.length + padLen, "=")), c =>
    c.charCodeAt(0)
  );
}

const AccountPage = ({ user }) => {
  const { isMobile, isTablet } = useContext(ResponsiveContext);
  const history = useHistory();
  const [path, setPath] = useState(
    history.location.pathname || "/account/security"
  );

  const handleClick = route => {
    history.push(route);
    setPath(route);
  };

  const tabs = [{ label: "Security", route: "/account/security" }];

  return (
    <div
      className={classNames(
        styles.pageWrapper,
        { [styles.pageWrapperMobile]: isMobile },
        { [styles.pageWrapperMobile]: isTablet }
      )}
    >
      <div
        className={classNames(
          styles.pageOptions,
          { [styles.pageOptionsMobile]: isMobile },
          { [styles.pageOptionsMobile]: isTablet }
        )}
      >
        <div
          style={{
            marginTop: "45px",
            marginLeft: "10px",
            marginBottom: "45px"
          }}
        >
          <Typography align="left" color="inherit" variant="h4">
            Account
          </Typography>
        </div>

        {tabs.map(tab => (
          <div
            key={tab.label}
            className={
              path === tab.route ? styles.activeHeading : styles.heading
            }
            onClick={() => handleClick(tab.route)}
          >
            <Typography align="left" color="inherit" variant="h5">
              {tab.label}
            </Typography>
          </div>
        ))}
      </div>
      <div
        className={classNames(
          styles.pageContent,
          { [styles.pageContentMobile]: isMobile },
          { [styles.pageOptionsMobile]: isTablet }
        )}
      >
        <Switch>
          <Route path={"/account/security"}>
            <AccountSecurity user={user} />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

const AccountSecurity = ({ user }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [passKeys, setPassKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const deviceName = platform?.os?.toString() || platform?.description;
  const { isMobile, isTablet } = useContext(ResponsiveContext);
  // const [error, setError] = useState(null);

  const getPasskeys = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(
        `user/mfa/credentials`,
        undefined,
        history
      );
      setTimeout(() => {
        setLoading(false);
        setPassKeys(response);
      }, 350);
    } catch (err) {
      setLoading(false);
      console.error("Error fetching passkeys:", err);
    }
  }, [history]);

  useEffect(() => {
    getPasskeys();
  }, [getPasskeys]);

  // const handleCheckboxChange = async () => {
  //   const newMfa = !mfa;
  //   const mfaValue = newMfa ? 1 : 0;
  //   const options = { body: JSON.stringify({}) };
  //   const updatedMfa = await api.put(
  //     `user/mfa/${user?.id}/${mfaValue}`,
  //     options,
  //     history
  //   );
  // if (updatedMfa == true) {
  //   setMfa(!mfa);
  // }
  //   debugger;
  //   setMfa(!mfa);
  // };

  const createPasskey = async () => {
    const passkeyOptions = await api.get(
      `fido2/credential-options`,
      undefined,
      history
    );

    passkeyOptions.challenge = base64URLToBuffer(passkeyOptions?.challenge);
    passkeyOptions.user.id = base64URLToBuffer(passkeyOptions?.user?.id);

    const passkeyCredentials = await navigator.credentials.create({
      publicKey: passkeyOptions
    });

    const options = { body: JSON.stringify(passkeyCredentials) };
    const savedPasskey = await api.put(
      `fido2/${user?.id}/credential?deviceName=${deviceName}`,
      options,
      history
    );
    console.log("savedPasskey", savedPasskey);
    getPasskeys();
  };

  const handleDelete = async passkey => {
    if (
      window.confirm(`${t("Are you sure you want to delete passkey")}${t("?")}`)
    ) {
      setLoading(true);
      const response = await api.delete(
        `user/mfa/${passkey?.recId}`,
        null,
        history
      );
      console.log("response", response);
      getPasskeys();
    }
  };

  const formatDate = newDate => {
    const date = new Date(newDate);
    const formatter = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    }); // Output: April 7, 2025

    const formattedDate = formatter.format(date);
    return formattedDate;
  };

  return (
    <div>
      <div
        className={classNames(
          styles.title,
          { [styles.titleMobile]: isMobile },
          { [styles.pageOptionsMobile]: isTablet }
        )}
      >
        <Typography align="left" variant="h4">
          {t("Security")}
        </Typography>
      </div>
      {/* <FormGroup className={styles.checkboxMargin}>
        <FormControlLabel
          control={<Checkbox checked={mfa} onChange={handleCheckboxChange} />}
          label="Require Multi-Factor Authentication to sign in (recommended)."
        />
      </FormGroup> */}
      <div
        className={classNames(
          styles.passkeyHeader,
          { [styles.passkeyHeaderMobile]: isMobile },
          { [styles.passkeyHeaderMobile]: isTablet }
        )}
      >
        <Typography align="left" variant="h6" style={{ lineHeight: 0 }}>
          <img
            src={fidoPasskeyLogo}
            alt="Fido Passkey Logo"
            cursor="pointer"
            className={styles.keyIcon}
          />
        </Typography>
        <Typography align="left" variant="h6" style={{ paddingRight: 90 }}>
          {t("Passkeys")}
        </Typography>
        <Fab
          classes={{ root: styles.addButton }}
          onClick={createPasskey}
          size="medium"
          color="primary"
        >
          <AddIcon />
        </Fab>
      </div>
      <div
        className={classNames(
          styles.passkeyList,
          { [styles.passkeyListMobile]: isMobile },
          { [styles.passkeyHeaderMobile]: isTablet }
        )}
      >
        {loading && <Spinner />}
        {passKeys.map((passKey, index) => (
          <>
            <div>{`${passKey.deviceName || user.email} (created ${formatDate(
              passKey.created
            )})`}</div>
            <div onClick={() => handleDelete(passKey)}>
              <Delete style={{ fill: "Black", cursor: "pointer" }} />
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default AccountPage;
